import React from 'react';
import { connect } from 'redux-bundler-react';
import LegendItemNotShown from './legend-item-notshown';
import LegendItemCorpsMap from './legend-item-corpsmap';
import LegendItemArcGIS from './legend-item-arcgis';
import LegendItemWMS from './legend-item-wms';
import sortBy from 'lodash/sortBy';

class LegendPanel extends React.Component {
  constructor(props){
    super(props);
    this.renderItems = this.renderItems.bind(this);
    this.renderDsLegendCluster= this.renderDsLegendCluster.bind(this);
  }
  renderDsLegendCluster(key){
    return (
      
      <li key={key} className="list-group-item">
        {/* <div className="overflow-ellipsis" title='Library'><strong>Library Types</strong></div> */}
        <div><i className="ds ds-damicon icon-inline"/> National Inventory of Dams Structure</div>
      </li>
    )
  }
  renderItems(){
    const { visibleLayers } = this.props;
    const sortedLayers = sortBy(visibleLayers, ['sortOrder']).reverse();
    if(visibleLayers.length > 0) {
      return sortedLayers.map((layer, i) => {
        if(layer.dsName === 'NID' && layer.geometryType ==='VECTOR_CLUSTER') return this.renderDsLegendCluster(i)
        if(layer.type.indexOf('Vector') !== -1) return <LegendItemNotShown key={i} layer={layer} />; //@TODO legends for vector data
        if(layer.geometryType !== 'SERVICE' && layer.dsName !=='NSI') return <LegendItemCorpsMap key={i} layer={layer} />
        if(layer.type.indexOf('Arc') !== -1) return <LegendItemArcGIS key={i} layer={layer} />
        return <LegendItemWMS key={i} layer={layer} />
      })
    }else{
      return (
        <li className="list-group-item">
          <div className="overflow-ellipsis" title='No Visible Layers'><strong>No Visible Layers</strong></div>
        </li>
      )
    }
    
  }

  render(){
    
    return (
      <div>
        <ul className="list-group sidebar-list thin-scrollbar">
          {/* {
            this.renderDsLegendCluster()
          } */}
          {
            this.renderItems()
          }
        </ul>
      </div>
    )
  }
}

export default connect(
  'selectVisibleLayers',
  LegendPanel
);